export default __webpack_public_path__ + "static/media/2.ff8e8f65.png";